import request from '@/utils/request'

// 通过或视频、图片、音频数据
export function getDate(query) { return request({ url: '/evaluation_resource/info', method: 'get', params: query }) }
// 获取学期
export function getTrem() { return request({ url: `/term/current`, method: 'get', }) }
// 获取评估和训练权限
export function getPermissions() { return request({ url: `/sys/menu/permissions`, method: 'get', }) }

// 培智课程IEP
// 根据id查询iep列表
export function getIEPList(query) { return request({ url: `/course_iep/infoAll/${query}`, method: 'get', }) }
// 新增iep计划
export function addIEP(query) { return request({ url: `/course_iep/save`, method: 'post', data: query }) }
// 修改iep计划
export function putIEP(query) { return request({ url: `/course_iep/update`, method: 'put', data: query }) }
// 根据iep的id获取iep详情
export function getIEPInfo(query) { return request({ url: `/course_iep/info/${query}`, method: 'get', }) }
// 删除iep计划
export function delIEP(query) { return request({ url: `/course_iep/del/${query}`, method: 'delete', data: query }) }


// 生活适应
// 学生列表/evaluation_adapt/studentPage
export function studengAdaptEvaluationList(query) { return request({ url: '/evaluation_adapt/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getStudentIdAdaptEvaluation(query) { return request({ url: `/evaluation_adapt/infoAll`, method: 'get', params: query }) }
// 学生信息
export function getInfoAdaptEvaluation(query) { return request({ url: '/evaluation_adapt/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessAdaptEvaluation(query) { return request({ url: `/evaluation_adapt/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessAdaptEvaluation(query) { return request({ url: `/evaluation_adapt/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getAdaptEvaluationTopic(query) { return request({ url: `/evaluation_adapt/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailAdaptEvaluation(query) { return request({ url: `/evaluation_adapt/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportAdaptEvaluation(query) { return request({ url: `/evaluation_adapt/analysis//${query}`, method: 'get' }) }
// 根据学生id查询最新的保存记录id 
export function getLastSaveRecordIdAdaptEvaluation(studentId) { return request({ url: `/evaluation_adapt/findEvaluationId/${studentId}`, method: 'get', }) }

// 生活数学
// 学生列表/evaluation_math/studentPage
export function studengMathEvaluationList(query) { return request({ url: '/evaluation_math/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getStudentIdMathEvaluation(query) { return request({ url: `/evaluation_math/infoAll`, method: 'get', params: query }) }
// 学生信息
export function getInfoMathEvaluation(query) { return request({ url: '/evaluation_math/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessMathEvaluation(query) { return request({ url: `/evaluation_math/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessMathEvaluation(query) { return request({ url: `/evaluation_math/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getMathEvaluationTopic(query) { return request({ url: `/evaluation_math/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailMathEvaluation(query) { return request({ url: `/evaluation_math/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportMathEvaluation(query) { return request({ url: `/evaluation_math/analysis//${query}`, method: 'get' }) }
// 根据学生id查询最新的保存记录id 
export function getLastSaveRecordIdMathEvaluation(studentId) { return request({ url: `/evaluation_math/findEvaluationId/${studentId}`, method: 'get', }) }

// 生活语文
// 学生列表
export function studengChineseEvaluationList(query) { return request({ url: '/evaluation_chinese/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getStudentIdChineseEvaluation(query) { return request({ url: `/evaluation_chinese/infoAll`, method: 'get', params: query }) }
// 学生信息
export function getInfoChineseEvaluation(query) { return request({ url: '/evaluation_chinese/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessChineseEvaluation(query) { return request({ url: `/evaluation_chinese/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessChineseEvaluation(query) { return request({ url: `/evaluation_chinese/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getChineseEvaluationTopic(query) { return request({ url: `/evaluation_chinese/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailChineseEvaluation(query) { return request({ url: `/evaluation_chinese/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportChineseEvaluation(query) { return request({ url: `/evaluation_chinese/analysis//${query}`, method: 'get' }) }
// 根据学生id查询最新的保存记录id 
export function getLastSaveRecordIdChineseEvaluation(studentId) { return request({ url: `/evaluation_chinese/findEvaluationId/${studentId}`, method: 'get', }) }


// S−S语言发育迟缓检查法
// 学生列表/evaluation_ss/studentPage
export function studengSsEvaluationList(query) { return request({ url: '/evaluation_ss/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdSsEvaluation(studentId) { return request({ url: `/evaluation_ss/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoSsEvaluation(query) { return request({ url: '/evaluation_ss/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessSsEvaluation(query) { return request({ url: `/evaluation_ss/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessSsEvaluation(query) { return request({ url: `/evaluation_ss/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getSsEvaluationTopic(query) { return request({ url: `/evaluation_ss/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailSsEvaluation(query) { return request({ url: `/evaluation_ss/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportSsEvaluation(query) { return request({ url: `/evaluation_ss/analysis//${query}`, method: 'get' }) }
// 根据学生id查询最新的保存记录id 
export function getLastSaveRecordIdSsEvaluation(studentId) { return request({ url: `/evaluation_ss/findEvaluationId/${studentId}`, method: 'get', }) }


// 瑞文经典之智力测验
// 学生列表/evaluation_rw/studentPage
export function studengRwList(query) { return request({ url: '/evaluation_rw/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdRw(studentId) { return request({ url: `/evaluation_rw/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoRw(query) { return request({ url: '/evaluation_rw/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessRw(query) { return request({ url: `/evaluation_rw/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessRw(query) { return request({ url: `/evaluation_rw/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getRwTopic(query) { return request({ url: `/evaluation_rw/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailRw(query) { return request({ url: `/evaluation_rw/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportRw(query) { return request({ url: `/evaluation_rw/analysis//${query}`, method: 'get' }) }


// 社交行为SRS
// 学生列表/evaluation_srs/studentPage
export function studengSrsList(query) { return request({ url: '/evaluation_srs/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdSrs(studentId) { return request({ url: `/evaluation_srs/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoSrs(query) { return request({ url: '/evaluation_srs/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessSrs(query) { return request({ url: `/evaluation_srs/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessSrs(query) { return request({ url: `/evaluation_srs/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getSrsTopic(query) { return request({ url: `/evaluation_srs/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailSrs(query) { return request({ url: `/evaluation_srs/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportSrs(query) { return request({ url: `/evaluation_srs/analysis//${query}`, method: 'get' }) }




// 感官统合
// 学生列表
export function studengIntegrationList(query) { return request({ url: '/evaluation_integration/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdIntegration(studentId) { return request({ url: `/evaluation_integration/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoIntegration(query) { return request({ url: '/evaluation_integration/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessIntegration(query) { return request({ url: `/evaluation_integration/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessIntegration(query) { return request({ url: `/evaluation_integration/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getIntegrationTopic(query) { return request({ url: `/evaluation_integration/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailIntegration(query) { return request({ url: `/evaluation_integration/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportIntegration(query) { return request({ url: `/evaluation_integration/analysis//${query}`, method: 'get' }) }



// 情绪行为
// 学生列表/evaluation_emotion/studentPage
export function studengEmotionList(query) { return request({ url: '/evaluation_emotion/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdEmotion(studentId) { return request({ url: `/evaluation_emotion/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoEmotion(query) { return request({ url: '/evaluation_emotion/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessEmotion(query) { return request({ url: `/evaluation_emotion/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessEmotion(query) { return request({ url: `/evaluation_emotion/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getEmotionTopic(query) { return request({ url: `/evaluation_emotion/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailEmotion(query) { return request({ url: `/evaluation_emotion/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportEmotion(query) { return request({ url: `/evaluation_emotion/analysis//${query}`, method: 'get' }) }

// 社会交往
// 学生列表
export function studengSocialList(query) { return request({ url: '/evaluation_social/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdSocial(studentId) { return request({ url: `/evaluation_social/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoSocial(query) { return request({ url: '/evaluation_social/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessSocial(query) { return request({ url: `/evaluation_social/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessSocial(query) { return request({ url: `/evaluation_social/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getSocialTopic(query) { return request({ url: `/evaluation_social/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailSocial(query) { return request({ url: `/evaluation_social/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportSocial(query) { return request({ url: `/evaluation_social/analysis//${query}`, method: 'get' }) }

// 生活自理
// 学生列表
export function studengSelfcareList(query) { return request({ url: '/evaluation_selfcare/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdSelfcare(studentId) { return request({ url: `/evaluation_selfcare/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoSelfcare(query) { return request({ url: '/evaluation_selfcare/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessSelfcare(query) { return request({ url: `/evaluation_selfcare/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessSelfcare(query) { return request({ url: `/evaluation_selfcare/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getSelfcareTopic(query) { return request({ url: `/evaluation_selfcare/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailSelfcare(query) { return request({ url: `/evaluation_selfcare/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportSelfcare(query) { return request({ url: `/evaluation_selfcare/analysis//${query}`, method: 'get' }) }

// 认知能力
// 学生列表
export function studengCognitionList(query) { return request({ url: '/evaluation_cognition/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdCognition(studentId) { return request({ url: `/evaluation_cognition/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoCognition(query) { return request({ url: '/evaluation_cognition/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessCognition(query) { return request({ url: `/evaluation_cognition/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessCognition(query) { return request({ url: `/evaluation_cognition/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getCognitionTopic(query) { return request({ url: `/evaluation_cognition/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailCognition(query) { return request({ url: `/evaluation_cognition/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportCognition(query) { return request({ url: `/evaluation_cognition/analysis//${query}`, method: 'get' }) }

// 语言沟通
// 学生列表
export function studengLanguageList(query) { return request({ url: '/evaluation_language/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdLanguage(studentId) { return request({ url: `/evaluation_language/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoLanguage(query) { return request({ url: '/evaluation_language/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessLanguage(query) { return request({ url: `/evaluation_language/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessLanguage(query) { return request({ url: `/evaluation_language/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getLanguageTopic(query) { return request({ url: `/evaluation_language/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailLanguage(query) { return request({ url: `/evaluation_language/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportLanguage(query) { return request({ url: `/evaluation_language/analysis//${query}`, method: 'get' }) }


// 儿童孤独症评定量表CARS
// 学生列表
export function studengCarstList(query) { return request({ url: '/evaluation_cars/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdCars(studentId) { return request({ url: `/evaluation_cars/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoCars(query) { return request({ url: '/evaluation_cars/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessCars(query) { return request({ url: `/evaluation_cars/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessCars(query) { return request({ url: `/evaluation_cars/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getCarsTopic(query) { return request({ url: `/evaluation_cars/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailCars(query) { return request({ url: `/evaluation_cars/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportCars(query) { return request({ url: `/evaluation_cars/analysis//${query}`, method: 'get' }) }


// 孤独症Conners教师用量表评估
// 学生列表
export function studengConnerstList(query) { return request({ url: '/evaluation_connerst/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdConnersT(studentId) { return request({ url: `/evaluation_connerst/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoConnerst(query) { return request({ url: '/evaluation_connerst/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessConnerst(query) { return request({ url: `/evaluation_connerst/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessConnerst(query) { return request({ url: `/evaluation_connerst/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getConnerstTopic(query) { return request({ url: `/evaluation_connerst/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailConnerst(query) { return request({ url: `/evaluation_connerst/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportConnerst(query) { return request({ url: `/evaluation_connerst/analysis//${query}`, method: 'get' }) }

// 孤独症Conners父母用量表评估
// 学生列表
export function studengConnersfList(query) { return request({ url: '/evaluation_connersf/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdConnersf(studentId) { return request({ url: `/evaluation_connersf/infoAll/${studentId}`, method: 'get', }) }
// 学生信息
export function getInfoConnersf(query) { return request({ url: '/evaluation_connersf/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessConnersf(query) { return request({ url: `/evaluation_connersf/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessConnersf(query) { return request({ url: `/evaluation_connersf/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getConnersfTopic(query) { return request({ url: `/evaluation_connersf/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailConnersf(query) { return request({ url: `/evaluation_connersf/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportConnersf(query) { return request({ url: `/evaluation_connersf/analysis//${query}`, method: 'get' }) }

// 孤独症---ABC量表
// 学生列表
export function studengABCList(query) { return request({ url: '/evaluation_abc/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdABC(studentId) { return request({ url: `/evaluation_abc/infoAll/${studentId}`, method: 'get', }) }
// 保存
export function getSaveAessABC(query) { return request({ url: `/evaluation_abc/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessABC(query) { return request({ url: `/evaluation_abc/finished`, method: 'post', data: query }) }
// 根据报告id获取报告详情
export function getAssessDetailABC(query) { return request({ url: `/evaluation_abc/info/${query}`, method: 'get' }) }
// 继续或得分详情
export function getABCTopic(query) { return request({ url: `/evaluation_abc/infoContinue`, method: 'get', params: query }) }
// 学生信息
export function getInfoABC(query) { return request({ url: '/evaluation_abc/infoNew', method: 'get', params: query }) }
// 对比分析
export function analysisReportABC(query) { return request({ url: `/evaluation_abc/analysis//${query}`, method: 'get' }) }

// 孤独症CPEP3
// 学生列表
export function studengCpep3List(query) { return request({ url: '/evaluation_cpep3/studentPage', method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdCpep3(studentId) { return request({ url: `/evaluation_cpep3/infoAll/${studentId}`, method: 'get', }) }
// 保存
export function getSaveAessCpep3(query) { return request({ url: `/evaluation_cpep3/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessCpep3(query) { return request({ url: `/evaluation_cpep3/finished`, method: 'post', data: query }) }
// 根据报告id获取报告详情
export function getAssessDetailCpep3(query) { return request({ url: `/evaluation_cpep3/info/${query}`, method: 'get' }) }
// 继续或得分详情
export function getCpep3Topic(query) { return request({ url: `/evaluation_cpep3/infoContinue`, method: 'get', params: query }) }
// 学生信息
export function getInfoCpep3(query) { return request({ url: '/evaluation_cpep3/infoNew', method: 'get', params: query }) }
// 对比分析
export function analysisReportCpep3(query) { return request({ url: `/evaluation_cpep3/analysis//${query}`, method: 'get' }) }

// 感官知觉
// 学生列表
export function studengSenseList(query) { return request({ url: '/evaluation_sense/studentPage', method: 'get', params: query }) }
// 学生信息
export function getInfoSense(query) { return request({ url: '/evaluation_sense/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessSense(query) { return request({ url: `/evaluation_sense/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessSense(query) { return request({ url: `/evaluation_sense/finished`, method: 'post', data: query }) }
// 继续评估获取评估详情
export function getSenseTopic(query) { return request({ url: `/evaluation_sense/infoContinue`, method: 'get', params: query }) }
//根据学生ID查询学生的评估列表
export function getEvaluationDetailByStudentIdSense(studentId) { return request({ url: `/evaluation_sense/infoAll/${studentId}`, method: 'get', }) }
// 根据报告id获取报告详情
export function getAssessDetailSense(query) { return request({ url: `/evaluation_sense/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportlSense(query) { return request({ url: `/evaluation_sense/analysis//${query}`, method: 'get' }) }


// 儿童行为量表
// 学生列表
export function studengCbclList(query) { return request({ url: '/evaluationCbcl/studentPage', method: 'get', params: query }) }
// 学生信息
export function getInfoCbcl(query) { return request({ url: '/evaluationCbcl/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessCbcl(query) { return request({ url: `/evaluationCbcl/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessCbcl(query) { return request({ url: `/evaluationCbcl/finished`, method: 'post', data: query }) }
// 继续或得分详情
export function getCbclTopic(query) { return request({ url: `/evaluationCbcl/infoContinue`, method: 'get', params: query }) }
//根据学生ID查询学生的Mht评估列表
export function getEvaluationDetailByStudentIdCbcl(studentId) { return request({ url: `/evaluationCbcl/infoAll/${studentId}`, method: 'get', }) }
// 根据报告id获取报告详情
export function getAssessDetailCbcl(query) { return request({ url: `/evaluationCbcl/info/${query}`, method: 'get' }) }
// 对比分析
export function analysisReportCbcl(query) { return request({ url: `/evaluationCbcl/analysis//${query}`, method: 'get' }) }


// 学生心理健康
export function studengMhtList(query) { return request({ url: '/evaluationMht/studentPage', method: 'get', params: query }) }
// 学生信息
export function getInfoMht(query) { return request({ url: '/evaluationMht/infoNew', method: 'get', params: query }) }
// 保存
export function getSaveAessMht(query) { return request({ url: `/evaluationMht/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessMht(query) { return request({ url: `/evaluationMht/finished`, method: 'post', data: query }) }
//根据学生ID查询学生的Mht评估列表
export function getEvaluationDetailByStudentIdMht(studentId) { return request({ url: `/evaluationMht/infoAll/${studentId}`, method: 'get', }) }
// 根据报告id获取报告详情
export function getAssessDetailMht(query) { return request({ url: `/evaluationMht/info/${query}`, method: 'get' }) }
// 继续或得分详情
export function getMhtTopic(query) { return request({ url: `/evaluationMht/infoContinue`, method: 'get', params: query }) }
// 对比分析
export function analysisReportMht(query) { return request({ url: `/evaluationMht/analysis//${query}`, method: 'get' }) }



// 精细运动
// 学生列表
export function studengFmfmList(query) { return request({ url: '/evaluationFmfm/studentPage', method: 'get', params: query }) }
// 学生信息
export function getInfo(query) { return request({ url: '/evaluationFmfm/infoNew', method: 'get', params: query }) }
//根据学生ID查询学生的FMFM评估列表
export function getEvaluationDetailByStudentIdFmfm(studentId) { return request({ url: `/evaluationFmfm/infoAll/${studentId}`, method: 'get', }) }

// 保存精细运动
export function getSaveAess(query) { return request({ url: `/evaluationFmfm/save`, method: 'post', data: query }) }

// 结束评估
export function getFinishedAess(query) { return request({ url: `/evaluationFmfm/finished`, method: 'post', data: query }) }
// 获取评估详情
export function getAssessDetail(query) { return request({ url: `/evaluationFmfm/info/${query}`, method: 'get' }) }
// 下载报告
export function downloadReportFmfm(query) { return request({ url: `/evaluationFmfm/downloadReport/${query}`, method: 'get' }) }
// 对比分析报告
export function analysisReportFmfm(query) { return request({ url: `/evaluationFmfm/analysis/${query}`, method: 'get' }) }
// 继续评估获取评估详情
export function getFmfmTopic(query) { return request({ url: `/evaluationFmfm/infoContinue`, method: 'get', params: query }) }
// 根据报告id获取报告详情
export function getAssessDetailFmfm(query) { return request({ url: `/evaluationFmfm/info/${query}`, method: 'get' }) }


// 粗大运动
// 精细运动学生列表
export function studengGmfmList(query) { return request({ url: '/evaluationGmfm/studentPage', method: 'get', params: query }) }
// 学生信息
export function getInfoGmfmm(query) { return request({ url: '/evaluationGmfm/infoNew', method: 'get', params: query }) }
// 保存运动
export function getSaveAessGmfm(query) { return request({ url: `/evaluationGmfm/save`, method: 'post', data: query }) }
// 结束评估
export function getFinishedAessGmfm(query) { return request({ url: `/evaluationGmfm/finished`, method: 'post', data: query }) }
//根据学生ID查询学生的FMFM评估列表
export function getEvaluationDetailByStudentIdGmfm(studentId) { return request({ url: `/evaluationGmfm/infoAll/${studentId}`, method: 'get', }) }
// 根据报告id获取报告详情
export function getAssessDetailGmfm(query) { return request({ url: `/evaluationGmfm/info/${query}`, method: 'get' }) }

// 对比分析报告
export function analysisReportGmfm(query) { return request({ url: `/evaluationGmfm/analysis/${query}`, method: 'get' }) }
// 继续评估获取评估详情
export function getTopicGmfm(query) { return request({ url: `/evaluationGmfm/infoContinue`, method: 'get', params: query }) }